import NakalKafalaList from "./NakalKafalaList";

export default function NakalKafalaTab({ setTrigger, trigger }) {
  return (
    <div className="p-2">
      <NakalKafalaList
        setTrigger={setTrigger}
        trigger={trigger}
      />
    </div>
  );
}
